import { render, staticRenderFns } from "./DemoExerciseErrorFeedbackComponent.vue?vue&type=template&id=fd2640fe&scoped=true&"
import script from "./DemoExerciseErrorFeedbackComponent.vue?vue&type=script&lang=js&"
export * from "./DemoExerciseErrorFeedbackComponent.vue?vue&type=script&lang=js&"
import style0 from "./DemoExerciseErrorFeedbackComponent.vue?vue&type=style&index=0&id=fd2640fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2640fe",
  null
  
)

export default component.exports